import React from 'react';

import GroupedTable from 'common/table/GroupedTable';
import { formatDateMmYyyy } from 'common/util/common-formatters';
import { getTargetArray } from 'common/util/common-helpers';

import { rate } from 'www/util/www-formatters';


export default ({details, currentOrIssuance, monthly, month}) => {
  const key = `${currentOrIssuance || month}.distributionsMap.NextInterestRateAdjDate`;
  const data = currentOrIssuance ? details.data : monthly.data;
  const tableData = getTargetArray(data, key);

  const config = {
    className: 'distribution-table',
    columnEmptyText: '-',
    columns: [
      { key: 'label', formatter: formatDateMmYyyy, flex: 0.5 },
      { key: 'waInterestRateCurrent', group: 'Interest Rate - Current', label: 'Weighted Average', formatter: rate, className: 'right' },
      { key: 'interestRateHighCurrent', group: 'Interest Rate - Current', label: 'High', formatter: rate, className: 'right' },
      { key: 'interestRateLowCurrent', group: 'Interest Rate - Current', label: 'Low', formatter: rate, className: 'right' },
      { key: 'waNetInterestRateCurrent', group: 'Net Interest Rate - Current', label: 'Weighted Average', formatter: rate, className: 'right' },
      { key: 'netInterestRateHighCurrent', group: 'Net Interest Rate - Current', label: 'High', formatter: rate, className: 'right' },
      { key: 'netInterestRateLowCurrent', group: 'Net Interest Rate - Current', label: 'Low', formatter: rate, className: 'right' },
      { key: 'waMortgageMargin', group: 'Mortgage Margin', label: 'Weighted Average', formatter: rate, className: 'right' },
      { key: 'mortgageMarginHigh', group: 'Mortgage Margin', label: 'High', formatter: rate, className: 'right' },
      { key: 'mortgageMarginLow', group: 'Mortgage Margin', label: 'Low', formatter: rate, className: 'right' },
      { key: 'waMBSPCMargin', group: 'MBS Margin', label: 'Weighted Average', formatter: rate, className: 'right' },
      { key: 'mbsPCMarginHigh', group: 'MBS Margin', label: 'High', formatter: rate, className: 'right' },
      { key: 'mbsPCMarginLow', group: 'MBS Margin', label: 'Low', formatter: rate, className: 'right' }
    ],
    emptyText: 'No data'
  };


  return <GroupedTable config={config} data={tableData}/>;
};
